const REPLACED_REVISION_MESSAGE = 'This course was just published';

export const isReplacedRevisionError = (message: string | null): boolean =>
  !!message?.includes(REPLACED_REVISION_MESSAGE);
